import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { BrowserRouter as Router } from "react-router-dom";
import { CssBaseline, ThemeProvider } from "@mui/material";
import RootApp from "./Containers/App";
import { theme } from "./theme";
import { useEffect, useState } from "react";
import { UserContext } from "./Context/UserContext";
import { ToastProvider } from "./Components/Toast";
import {
  decodeAccessToken,
  getStoredAccessToken,
  hasValidStoredSession,
} from "./Utils/authSession";

export const muiCache = createCache({
  key: "kb",
});

declare global {
  interface Window {
    dataLayer: any;
  }
}

function App() {
  const [user, setUser] = useState<boolean | null>(() => {
    const token = getStoredAccessToken();
    if (!token) {
      return null;
    }
    return hasValidStoredSession() ? true : false;
  });

  useEffect(() => {
    if (!user) {
      return;
    }
    const token = getStoredAccessToken();
    if (!token) {
      return;
    }
    const decodedUser = decodeAccessToken(token);
    if (decodedUser?.unique_name) {
      window.dataLayer.push({
        event: "user_email",
        userEmail: decodedUser.unique_name,
      });
    }
  }, [user]);

  return (
    <CacheProvider value={muiCache}>
      <Router>
        <UserContext.Provider value={{ user, setUser }}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <ToastProvider>
              <RootApp />
            </ToastProvider>
          </ThemeProvider>
        </UserContext.Provider>
      </Router>
    </CacheProvider>
  );
}

export default App;
